import "./App.css";
import Checkout from "./Components/Checkout/Checkout";
import Header from "./Components/Header/Header";
import Home from "./Components/Home/Home";
import { Routes, Route } from "react-router-dom";
import Login from "./Components/Login/Login";
import Payment from "./Components/Payment/Payment";
import { useStateValue } from "./StateProvider";
import { useEffect, useRef } from "react";
import { auth } from "./Firebase";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import Orders from "./Components/Orders/Orders";
import Footer from "./Components/Footer/Footer";

const promise = loadStripe("pk_test_51MxljLArQDZWIjpY8LIVvtr8qpYSqsLPiLoq3VsvtuYlrshEtQ32iw7nsavxdnMSmd7ybVBI9ykj3xWi1S4gQJYi00KPtsNhBW");

function App() {
    const [{}, dispatch] = useStateValue();
    const clickRef = useRef();
    useEffect(() => {
        auth.onAuthStateChanged((authUser) => {
            if (authUser) {
                // user just logged in//
                dispatch({
                    type: "SET_USER",
                    user: authUser,
                });
            } else {
                // user logged out//
                dispatch({
                    type: "SET_USER",
                    user: null,
                });
            }
        });
    }, []);
    return (
        <div className="App" ref={clickRef}>
            <Routes>
                <Route
                    path="/checkout"
                    element={
                        <>
                            <Header />
                            <Checkout />
                        </>
                    }
                />
                <Route path="/login" element={<Login />} />
                <Route
                    path="/payment"
                    element={
                        <>
                            <Header />
                            <Elements stripe={promise}>
                                <Payment />
                            </Elements>
                        </>
                    }
                />
                <Route
                    path="/orders"
                    element={
                        <>
                            <Header />
                            <Orders />
                        </>
                    }
                />
                <Route
                    path="/"
                    element={
                        <>
                            <Header />
                            <Home />
                            <Footer />
                        </>
                    }
                />
                <Route
                    path="*"
                    element={
                        <>
                            <Header />
                            <Home />
                        </>
                    }
                />
            </Routes>
        </div>
    );
}

export default App;
